import _extends from "@babel/runtime/helpers/esm/extends";
import { useSuperIntl } from "./_";
import { ModalForm, ProFormCheckbox } from '@ant-design/pro-components';
import { Alert, Typography } from 'antd';
import React from 'react';
import { useStyles } from "./SimpleDeleter.style";
export var SimpleDeleter = function SimpleDeleter(properties) {
  var intl = useSuperIntl();
  var _useStyles = useStyles(),
    styles = _useStyles.styles;
  return /*#__PURE__*/React.createElement(ModalForm, _extends({
    width: 604,
    modalProps: {
      centered: true
    },
    submitter: {
      submitButtonProps: {
        danger: true
      }
    }
  }, properties), /*#__PURE__*/React.createElement(Alert, {
    banner: true,
    showIcon: true,
    type: "error",
    message: intl.formatMessage({
      id: 'This action cannot be'
    }),
    style: {
      margin: '-24px -24px 24px -24px'
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    style: {
      marginBottom: 12
    }
  }, /*#__PURE__*/React.createElement(Typography.Text, null, intl.formatMessage({
    id: 'Selected {count} items.'
  }, {
    count: properties.entities.length
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      marginBottom: 24,
      overflowY: 'auto',
      maxHeight: Math.pow(2, 8),
      padding: '12px 0 0',
      backgroundColor: '#F5F7FA'
    }
  }, properties.entities.map(function (entity) {
    return /*#__PURE__*/React.createElement("div", {
      key: entity === null || entity === void 0 ? void 0 : entity.uuid,
      style: {
        width: '50%',
        display: 'inline-block',
        padding: '0 12px',
        marginBottom: 12
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      className: styles.decorator
    }, /*#__PURE__*/React.createElement(Typography.Text, {
      ellipsis: true
    }, (entity === null || entity === void 0 ? void 0 : entity.name) || (entity === null || entity === void 0 ? void 0 : entity.uuid) || '-')));
  })), /*#__PURE__*/React.createElement(ProFormCheckbox.Group, {
    name: "",
    options: [intl.formatMessage({
      id: 'I am aware of'
    })],
    rules: [{
      required: true
    }],
    formItemProps: {
      style: {
        marginBottom: 0
      }
    }
  }));
};